// import React, { useState, useEffect } from "react";
// import { useLocation, useNavigate } from "react-router-dom";
// import axios from "axios";

// // Social Share Buttons
// import {
//   FacebookShareButton,
//   WhatsappShareButton,
//   TelegramShareButton,
//   EmailShareButton,
// } from "react-share";

// // FontAwesome Icons
// import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// import { faEnvelope, faDownload, faPrint } from "@fortawesome/free-solid-svg-icons";
// import { faWhatsapp, faFacebookMessenger, faTelegram } from "@fortawesome/free-brands-svg-icons";

// // PDF Generation
// import jsPDF from "jspdf";
// import "jspdf-autotable";

// // CSS Styles
// import "../styles/FullContent.css";
// import Navbar from "../components/Navbar";

// const FullContent = () => {
//   const location = useLocation();
//   const navigate = useNavigate();
//   const { content, query, summary, lawCategory: initialLawCategory, country, state, district } = location.state || {};
//   const [legalAdvisors, setLegalAdvisors] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [finalLawCategory, setFinalLawCategory] = useState(initialLawCategory);

//   useEffect(() => {
//     const fetchLegalAdvisors = async () => {
//       if (!district) return;
//       try {
//         const response = await axios.get("/api/legal-advisors/district", {
//           params: { district },
//         });
//         setLegalAdvisors(response.data);
//       } catch (error) {
//         console.error("Error fetching legal advisors:", error);
//       } finally {
//         setLoading(false);
//       }
//     };
//     fetchLegalAdvisors();
//   }, [district]);

//   const mergedSummary = `${summary ? summary + "\n\n" : ""}${content || ""}`;

//   useEffect(() => {
//     if (mergedSummary) {
//       const categoryRegex = /Law Category:\s*(.*)/i;
//       const match = mergedSummary.match(categoryRegex);
//       if (match && match[1]) {
//         setFinalLawCategory(match[1].trim());
//       }
//     }
//   }, [mergedSummary]);

//   const formatText = (text) => {
//     return text
//       .replace(/\*\*/g, "")
//       .split(/\r\n|\r|\n/)
//       .map((line, index) => <p key={index}>{line}</p>);
//   };

//   // Download PDF Function
//   const handleDownloadPDF = () => {
//     const doc = new jsPDF();
//     doc.setFont("helvetica", "bold");
//     doc.setFontSize(16);
//     doc.text("Legal Case Summary", 10, 10);

//     doc.setFont("helvetica", "normal");
//     doc.setFontSize(12);
//     doc.text(`Query: ${query}`, 10, 20);
//     doc.text(`Country: ${country}`, 10, 30);
//     doc.text(`State: ${state || "Not specified"}`, 10, 40);
//     doc.text(`Law Category: ${finalLawCategory}`, 10, 50);
//     doc.setFont("helvetica", "bold");
//     doc.text("Legal Summary:", 10, 60);
//     doc.setFont("helvetica", "normal");
//     doc.text(mergedSummary, 10, 70, { maxWidth: 180 });

//     doc.save("Legal_Case_Summary.pdf");
//   };

//   // Download Text File Function
//   const handleDownloadText = () => {
//     const element = document.createElement("a");
//     const file = new Blob(
//       [
//         `Query: ${query}\nCountry: ${country}\nState: ${state}\nLaw Category: ${finalLawCategory}\nLegal Summary:\n${mergedSummary}`,
//       ],
//       { type: "text/plain" }
//     );
//     element.href = URL.createObjectURL(file);
//     element.download = "Legal_Case_Summary.txt";
//     document.body.appendChild(element);
//     element.click();
//   };

//   const pageUrl = window.location.href;

//   return (

//     <div className="content-page">
//       <Navbar />
//       <div className="result-content-wrapper">
//         <div className="query-container">
//           <h2>Query:</h2>
//           <p>{query}</p>
//         </div>

//         <div className="content-sections">
//           <div className="top-info-container">
//             <div className="top-info-item">
//               <h3>Country:</h3>
//               <p>{country}</p>
//             </div>
//             {state && (
//               <div className="top-info-item">
//                 <h3>State:</h3>
//                 <p>{state}</p>
//               </div>
//             )}
//             <div className="top-info-item">
//               <h3>Law Category:</h3>
//               <p>{finalLawCategory}</p>
//             </div>
//           </div>

//           <div className="full-content-container">
//             <h1>Legal Summary</h1>
//             {mergedSummary.trim() && <div className="formatted-text">{formatText(mergedSummary)}</div>}
//           </div>
//         </div>

//         <div className="buttons-container">
//           <div className="download-buttons">
//             <button className="download-btn" onClick={handleDownloadPDF}>
//               <FontAwesomeIcon icon={faDownload} /> Download PDF
//             </button>
//             <button className="download-btn" onClick={handleDownloadText}>
//               <FontAwesomeIcon icon={faDownload} /> Download Text
//             </button>
//             <button className="download-btn" onClick={() => window.print()}>
//               <FontAwesomeIcon icon={faPrint} /> Print Page
//             </button>
//           </div>

//           <div className="share-buttons">
//             <WhatsappShareButton url={pageUrl} title={query}><FontAwesomeIcon icon={faWhatsapp} size="2x" /></WhatsappShareButton>
//             <TelegramShareButton url={pageUrl} title={query}><FontAwesomeIcon icon={faTelegram} size="2x" /></TelegramShareButton>
//             <FacebookShareButton url={pageUrl} quote={query}><FontAwesomeIcon icon={faFacebookMessenger} size="2x" /></FacebookShareButton>
//             <a className="mail" href={`mailto:?subject=Legal Case Summary&body=${query}%0A%0A${summary}%0ARead more: ${pageUrl}`}>
//               <FontAwesomeIcon icon={faEnvelope} size="2x" />
//             </a>
//           </div>
//         </div>
//       </div>
//       <div className="legal-advisors-container">
//         <h2>Suggested Legal Advisors</h2>
//         {/* Add Google Maps button for legal advisors based on location */}
//         <div style={{ marginBottom: "18px" }}>
//           <button
//             className="download-btn"
//             style={{ background: "#1976d2", color: "#fff", marginBottom: "10px" }}
//             onClick={() => {
//               // Build Google Maps search query for lawyers/advocates in the user's location
//               const queryParts = [
//                 "lawyer",
//                 "advocate",
//                 district,
//                 state,
//                 country
//               ].filter(Boolean);
//               const mapsQuery = encodeURIComponent(queryParts.join(" "));
//               window.open(`https://www.google.com/maps/search/${mapsQuery}`, "_blank");
//             }}
//           >
//             Find Legal Advisors on Google Maps
//           </button>
//         </div>
//         {loading ? (
//           <p>Loading legal advisors...</p>
//         ) : legalAdvisors.length > 0 ? (
//           <div className="advisor-grid">
//             {legalAdvisors.map((advisor) => (
//               <div key={advisor._id} className="advisor-card" onClick={() => navigate(`/legal-advisors/${advisor._id}`)}>
//                 <img
//                   src={advisor.profilePhoto || "/default-profile.png"}
//                   alt={`${advisor.firstName} ${advisor.lastName}`}
//                   className="advisor-image"
//                   onError={(e) => (e.target.src = "/default-profile.png")}
//                 />
//                 <div className="advisor-details">
//                   <h3>Adv. {advisor.firstName} {advisor.lastName}</h3>
//                   <p><strong>Specialization:</strong> {advisor.specialization}</p>
//                   <p><strong>District:</strong> {advisor.district || "Not specified"}</p>
//                 </div>
//               </div>
//             ))}
//           </div>
//         ) : (
//           <p>No legal advisors found in {district}. Try searching in nearby districts.</p>
//         )}
//       </div>
//     </div>
//   );
// };

// export default FullContent;


// frontend/src/pages/FullContent.js
import React, { useState, useEffect, useContext, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import axios from "axios";
import { faPen } from "@fortawesome/free-solid-svg-icons"; // import at the top
import { LanguageContext } from "../context/LanguageContext";

//DRTFGYUIOKP
// Social Share Buttons
import {
  FacebookShareButton,
  WhatsappShareButton,
  TelegramShareButton,
  EmailShareButton,
} from "react-share";

// FontAwesome Icons
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEnvelope, faDownload, faPrint, faVolumeUp, faStop } from "@fortawesome/free-solid-svg-icons";
import { faWhatsapp, faFacebookMessenger, faTelegram } from "@fortawesome/free-brands-svg-icons";

// PDF Generation
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";

// CSS Styles
import "../styles/FullContent.css";

const FullContent = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { selectedLanguage } = useContext(LanguageContext);
  const { content, query, summary, lawCategory: initialLawCategory, country, state, district, level = "professional", dbResults = [] } = location.state || {};
  const [loadingDeepResults, setLoadingDeepResults] = useState(false);
  const [isDeepView, setIsDeepView] = useState(false);
  const [deepContent, setDeepContent] = useState(null);
  const [deepProvider, setDeepProvider] = useState(null);
  const [isSpeaking, setIsSpeaking] = useState(false);
  const [voices, setVoices] = useState([]);
  const ttsContainerRef = useRef(null);
  
  // Store original content
  const originalContent = summary || content || "No legal information available.";

  // // Debug logging
  // console.log("FullContent - location.state:", location.state);
  // console.log("FullContent - dbResults:", dbResults);
  // console.log("FullContent - dbResults length:", dbResults.length);
  // console.log("FullContent - dbResults type:", typeof dbResults);

  // Use deep content if in deep view mode, otherwise use original
  const mergedSummary = isDeepView ? deepContent : originalContent;

  useEffect(() => {
    const synth = window.speechSynthesis;
    if (!synth) return undefined;

    const loadVoices = () => {
      const availableVoices = synth.getVoices();
      setVoices(Array.isArray(availableVoices) ? availableVoices : []);
    };

    loadVoices();
    synth.addEventListener("voiceschanged", loadVoices);

    return () => {
      synth.removeEventListener("voiceschanged", loadVoices);
      synth.cancel();
    };
  }, []);

  const getSpeechLanguage = () => {
    if (!selectedLanguage) return "en-US";
    if (selectedLanguage.includes("-")) return selectedLanguage;
    return `${selectedLanguage.toLowerCase()}-${selectedLanguage.toUpperCase()}`;
  };

  const resolveVoiceForLanguage = (langCode) => {
    if (!voices.length) return null;

    const normalized = (langCode || "en-US").toLowerCase();
    const exactMatch = voices.find((voice) => (voice.lang || "").toLowerCase() === normalized);
    if (exactMatch) return exactMatch;

    const baseLang = normalized.split("-")[0];
    return voices.find((voice) => (voice.lang || "").toLowerCase().startsWith(`${baseLang}-`)) || null;
  };

  const sanitizeTextForSpeech = (text) => {
    return String(text || "")
      .replace(/\*+/g, "")
      .split(/\r\n|\r|\n/)
      .map((line) =>
        line
          .replace(/^\s*[✅❌⚠️👉🧾🗣️🤝🎥🚨🧠📌🔹•\-]+\s*/u, "")
          .replace(/^\s*[IVXLCDM]+[\.):]\s+/i, "")
          .replace(/^\s*\d+[\.)]\s+/, "")
          .trim()
      )
      .filter(Boolean)
      .join(". ")
      .replace(/\s{2,}/g, " ")
      .trim();
  };

  const handleSpeakToggle = () => {
    const synth = window.speechSynthesis;
    if (!synth) {
      alert("Text-to-speech is not supported in this browser.");
      return;
    }

    if (isSpeaking) {
      synth.cancel();
      setIsSpeaking(false);
      return;
    }

    const visibleText = ttsContainerRef.current?.innerText?.trim() || mergedSummary?.trim() || "";
    const speechText = sanitizeTextForSpeech(visibleText);
    if (!speechText) return;

    synth.cancel();

    const utterance = new SpeechSynthesisUtterance(speechText);
    const speechLanguage = getSpeechLanguage();
    utterance.lang = speechLanguage;

    const selectedVoice = resolveVoiceForLanguage(speechLanguage);
    if (selectedVoice) utterance.voice = selectedVoice;

    utterance.onstart = () => setIsSpeaking(true);
    utterance.onend = () => setIsSpeaking(false);
    utterance.onerror = () => setIsSpeaking(false);

    synth.speak(utterance);
  };

  const formatText = (text) => {
    const cleaned = (text || "").replace(/\*\*/g, "");
    const lines = cleaned.split(/\r\n|\r|\n/);

    // Split a markdown table row ("| a | b |") into trimmed cells
    const splitRow = (row) =>
      String(row)
        .trim()
        .replace(/^\|/, "")
        .replace(/\|$/, "")
        .split("|")
        .map((cell) => cell.trim());

    // Horizontal rule: ---, ***, ___ (3 or more of the same char)
    const isDivider = (line) => /^\s*([-*_])\1{2,}\s*$/.test(line);
    // Table separator row: | --- | --- | (only pipes, dashes, colons, spaces)
    const isTableSeparator = (line) =>
      !!line && /^[\s|:-]+$/.test(String(line).trim()) && line.includes("-") && line.includes("|");

    const elements = [];

    for (let i = 0; i < lines.length; i++) {
      const trimmed = String(lines[i]).trim();

      // Markdown horizontal rule
      if (isDivider(trimmed)) {
        elements.push(<hr key={i} className="ai-divider" />);
        continue;
      }

      // Markdown table (header row followed by a separator row)
      if (trimmed.includes("|") && isTableSeparator(lines[i + 1])) {
        const header = splitRow(trimmed);
        const bodyRows = [];
        let j = i + 2;
        while (j < lines.length && lines[j].includes("|") && !isDivider(lines[j].trim())) {
          bodyRows.push(splitRow(lines[j]));
          j++;
        }

        elements.push(
          <div key={i} className="ai-table-wrap">
            <table className="ai-table">
              <thead>
                <tr>
                  {header.map((cell, ci) => (
                    <th key={ci}>{cell}</th>
                  ))}
                </tr>
              </thead>
              {bodyRows.length > 0 && (
                <tbody>
                  {bodyRows.map((cells, ri) => (
                    <tr key={ri}>
                      {cells.map((cell, ci) => (
                        <td key={ci}>{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              )}
            </table>
          </div>
        );

        i = j - 1;
        continue;
      }

      const withoutMarkdownHeading = trimmed.replace(/^#{1,6}[\s\u00A0]*/, "");
      const withoutBullet = withoutMarkdownHeading.replace(/^[-*][\s\u00A0]+/, "");
      const displayText = withoutBullet;

      const isMainHeading = /^[IVXLCDM]+\.[\s\u00A0]+/.test(displayText) || /^#{1,6}[\s\u00A0]+/.test(trimmed);
      const isNumberedStep = /^\d+\.[\s\u00A0]+/.test(displayText);
      const isBulletPoint = /^[-•*][\s\u00A0]+/.test(trimmed);
      const isEmojiPoint = /^[✅❌⚠️👉🧾🗣️🤝🎥🚨🧠📌🔹]/.test(displayText);
      const isLabel = /:$/.test(displayText) && displayText.length <= 40;

      let className = "";
      if (isMainHeading) className = "ai-heading";
      else if (isLabel) className = "ai-label";
      else if (isNumberedStep) className = "ai-step";
      else if (isBulletPoint || isEmojiPoint) className = "ai-point";

      if (!displayText) {
        elements.push(<p key={i} className="ai-blank">&nbsp;</p>);
        continue;
      }

      elements.push(
        <p key={i} className={className}>
          {displayText}
        </p>
      );
    }

    return elements;
  };

  const formatSearchLevel = (level) => {
    const levelMap = {
      'commonman': '👨🏻‍💼 Public Level (Simple & Easy)',
      'professional': '🧑‍💼 Professional (Advocate & Advisor)',
      'academic': '🧑‍🎓 Academic (Scholarly & Detailed)'
    };
    return levelMap[level] || '🧑‍💼 Professional (Advocate & Advisor)';
  };

  // Download PDF Function with multi-page support
  const handleDownloadPDF = () => {
    const doc = new jsPDF();
    const pageHeight = doc.internal.pageSize.height;
    const pageWidth = doc.internal.pageSize.width;
    const margin = 15;
    const lineHeight = 6;
    const maxLineWidth = pageWidth - (margin * 2);
    
    let yPosition = margin; // Start from top margin

    // The default jsPDF font (helvetica) can only encode Latin-1 characters,
    // so emojis/rupee sign/smart quotes come out as garbage (e.g. "Ø=Ý9").
    // Strip or convert those so the PDF stays readable.
    const sanitizeForPdf = (text) =>
      String(text || "")
        .replace(/\u20B9/g, "Rs.") // ₹ -> Rs.
        .replace(/[\u2018\u2019]/g, "'") // smart single quotes
        .replace(/[\u201C\u201D]/g, '"') // smart double quotes
        .replace(/[\u2013\u2014]/g, "-") // en/em dash
        .replace(/\u2026/g, "...") // ellipsis
        .replace(/[\u2044\u2215]/g, "/") // fraction / division slash -> normal slash
        .replace(/\u00A0/g, " ") // non-breaking space
        // The standard jsPDF font only supports Latin-1 (code points <= 255).
        // Anything above that (emoji, exotic punctuation, other scripts) breaks
        // width calculation -> garbled letter spacing and text overflowing the
        // box. Drop those leftover characters after the friendly conversions.
        .replace(/[^\x00-\xFF]/g, "");

    // Draw the ULJAAPP header at the given y; returns the y after the header
    const drawHeaderAt = (y) => {
      doc.setFont("helvetica", "bold");
      doc.setFontSize(14);
      doc.text("ULJAAPP", margin, y);
      let ny = y + 5;
      doc.setDrawColor(200, 200, 200);
      doc.setLineWidth(0.2);
      doc.line(margin, ny, pageWidth - margin, ny);
      return ny + 8;
    };

    // Add company header first
    yPosition = drawHeaderAt(yPosition);

    // Helper function to add text with automatic page breaks
    const addTextWithPageBreaks = (text, x, fontSize = 12, fontStyle = "normal", fontWeight = "normal") => {
      doc.setFont("helvetica", fontWeight);
      doc.setFontSize(fontSize);
      
      // Split text into lines that fit within the page width
      const lines = doc.splitTextToSize(sanitizeForPdf(text), maxLineWidth);
      
      for (let i = 0; i < lines.length; i++) {
        // Check if we need a new page
        if (yPosition + lineHeight > pageHeight - margin) {
          doc.addPage();
          yPosition = drawHeaderAt(margin);
          
          // Reset font for content
          doc.setFont("helvetica", fontWeight);
          doc.setFontSize(fontSize);
        }
        
        doc.text(lines[i], x, yPosition);
        yPosition += lineHeight;
      }
      
      return yPosition;
    };
    
    
    // Add main title immediately after header
    yPosition = addTextWithPageBreaks("Legal Case Summary", margin, 16, "normal", "bold");
    yPosition += 2;
    
    // Add query
    yPosition = addTextWithPageBreaks(`Query: ${query}`, margin, 12, "normal", "bold");
    yPosition += 2;
    
    // Add country
    yPosition = addTextWithPageBreaks(`Country: ${country}`, margin, 12);
    yPosition += 2;
    
    // Add state (if available)
    if (state) {
      yPosition = addTextWithPageBreaks(`State: ${state}`, margin, 12);
      yPosition += 2;
    }
    
    
    // Add search level
    yPosition = addTextWithPageBreaks(`Search Level: ${formatSearchLevel(level)}`, margin, 12);
    yPosition += 3;
    
    // Add legal summary header
    yPosition = addTextWithPageBreaks("Legal Summary:", margin, 12, "normal", "bold");
    yPosition += 2;
    
    // Add the main content with automatic page breaks.
    // Parse the markdown so dividers (---) and tables (| a | b |) render
    // properly instead of leaking through as raw symbols.
    if (mergedSummary && mergedSummary.trim()) {
      const contentLines = mergedSummary
        .replace(/\*\*/g, "") // Remove bold markers
        .replace(/\*/g, "") // Remove italic markers
        .split(/\r\n|\r|\n/);

      const splitRow = (row) =>
        String(row)
          .trim()
          .replace(/^\|/, "")
          .replace(/\|$/, "")
          .split("|")
          .map((cell) => sanitizeForPdf(cell.trim()));

      const isDivider = (line) => /^\s*([-*_])\1{2,}\s*$/.test(line);
      const isTableSeparator = (line) =>
        !!line && /^[\s|:-]+$/.test(String(line).trim()) && line.includes("-") && line.includes("|");

      for (let i = 0; i < contentLines.length; i++) {
        const trimmed = String(contentLines[i]).trim();

        // Blank line -> small vertical gap
        if (!trimmed) {
          yPosition += 2;
          continue;
        }

        // Horizontal rule
        if (isDivider(trimmed)) {
          if (yPosition + 6 > pageHeight - margin) {
            doc.addPage();
            yPosition = drawHeaderAt(margin);
          }
          doc.setDrawColor(220, 220, 220);
          doc.setLineWidth(0.2);
          doc.line(margin, yPosition, pageWidth - margin, yPosition);
          yPosition += 5;
          continue;
        }

        // Markdown table (header row followed by a separator row)
        if (trimmed.includes("|") && isTableSeparator(contentLines[i + 1])) {
          const head = [splitRow(trimmed)];
          const body = [];
          let j = i + 2;
          while (
            j < contentLines.length &&
            contentLines[j].includes("|") &&
            !isDivider(contentLines[j].trim())
          ) {
            body.push(splitRow(contentLines[j]));
            j++;
          }

          autoTable(doc, {
            startY: yPosition,
            head,
            body,
            styles: { font: "helvetica", fontSize: 9, cellPadding: 2, overflow: "linebreak", textColor: [51, 51, 51] },
            headStyles: { fillColor: [234, 244, 244], textColor: [25, 118, 210], fontStyle: "bold" },
            margin: { left: margin, right: margin, top: margin + 13 },
            didDrawPage: () => drawHeaderAt(margin),
          });

          yPosition = (doc.lastAutoTable ? doc.lastAutoTable.finalY : yPosition) + 4;
          i = j - 1;
          continue;
        }

        // Regular line / heading
        const cleanLine = sanitizeForPdf(
          trimmed.replace(/^#{1,6}\s*/, "").replace(/^[-•]\s+/, "")
        ).trim();
        if (!cleanLine) {
          yPosition += 2;
          continue;
        }

        const isHeading = /^#{1,6}\s+/.test(trimmed) || /^[IVXLCDM]+\.\s+/.test(cleanLine);
        if (isHeading) {
          yPosition += 2;
          yPosition = addTextWithPageBreaks(cleanLine, margin, 12, "normal", "bold");
        } else {
          yPosition = addTextWithPageBreaks(cleanLine, margin, 11);
        }
      }
    }
    
    // Add disclaimer at the bottom of the last page
    yPosition += 5; // Small spacing before disclaimer
    
    // Check if we need a new page for disclaimer
    const disclaimerText = "Disclaimer: This information is for general guidance only and should not be considered as legal advice. Please consult with a qualified legal professional for advice specific to your situation.";
    const disclaimerLines = doc.splitTextToSize(disclaimerText, maxLineWidth);
    const disclaimerHeight = disclaimerLines.length * lineHeight + 15; // Extra space for styling
    
    if (yPosition + disclaimerHeight > pageHeight - margin) {
      doc.addPage();
      yPosition = margin;
      
      // Add header to new page
      doc.setFont("helvetica", "bold");
      doc.setFontSize(14);
      doc.text("ULJAAPP", margin, yPosition);
      yPosition += 5;
      doc.setDrawColor(200, 200, 200);
      doc.line(margin, yPosition, pageWidth - margin, yPosition);
      yPosition += 8;
    }
    
    // Add disclaimer with border
    doc.setFontSize(10);
    doc.setFont("helvetica", "normal");
    
    // Draw border around disclaimer
    const disclaimerStartY = yPosition;
    doc.setDrawColor(255, 193, 7); // Warning color
    doc.setLineWidth(0.5);
    doc.rect(margin, disclaimerStartY - 5, maxLineWidth, disclaimerHeight);
    
    yPosition += 3;
    yPosition = addTextWithPageBreaks("DISCLAIMER:", margin + 5, 10, "normal", "bold");
    yPosition = addTextWithPageBreaks(disclaimerText, margin + 5, 9);
    
    doc.save("Legal_Case_Summary.pdf");
  };

  // Download Text File Function
  const handleDownloadText = () => {
    const element = document.createElement("a");
    const file = new Blob(
      [
        `Query: ${query}\nCountry: ${country}\nState: ${state}\nSearch Level: ${formatSearchLevel(level)}\nLegal Summary:\n${mergedSummary}`,
      ],
      { type: "text/plain" }
    );
    element.href = URL.createObjectURL(file);
    element.download = "Legal_Case_Summary.txt";
    document.body.appendChild(element);
    element.click();
  };

  // Enhanced Print Function
  const handlePrint = () => {
    // Add class to hide elements during print
    document.body.classList.add('pdf-export-mode');
    
    // Create a style element to inject additional print styles
    const printStyles = document.createElement('style');
    printStyles.textContent = `
      @media print {
        /* Force everything to start from top */
        *, *::before, *::after {
          box-sizing: border-box !important;
        }
        
        /* Reset margins and padding aggressively */
        html, body {
          margin: 0 !important;
          padding: 0 !important;
          height: auto !important;
        }
        
        @page {
          margin: 0.3in !important;
          size: A4;
        }
        
        /* Force main elements to have no spacing */
        .main-wrapper, .two-column-layout, .content-page, .result-content-wrapper {
          margin: 0 !important;
          padding: 0 !important;
          background: white !important;
          page-break-before: avoid !important;
        }
        
        /* Ultra compact navbar */
        .navbar {
          display: block !important;
          visibility: visible !important;
          background: white !important;
          border-bottom: 1px solid #ddd !important;
          padding: 2px 0 !important;
          margin: 0 !important;
          height: auto !important;
          min-height: auto !important;
        }
        
        .header-content {
          display: flex !important;
          align-items: center !important;
          gap: 8px !important;
          margin: 0 !important;
          padding: 0 !important;
          height: auto !important;
        }
        
        .site-logo {
          display: block !important;
          visibility: visible !important;
          max-height: 25px !important;
          margin: 0 !important;
          padding: 0 !important;
        }
        
        .header-title {
          display: block !important;
          visibility: visible !important;
          color: #000 !important;
          font-size: 14px !important;
          font-weight: bold !important;
          margin: 0 !important;
          padding: 0 !important;
          line-height: 1.2 !important;
        }
        
        /* Ultra compact content */
        .query-container, .top-info-container, .full-content-container {
          margin: 1px 0 !important;
          padding: 1px 0 !important;
          background: white !important;
          border: none !important;
          page-break-before: avoid !important;
        }
        
        .query-container h2 {
          font-size: 16px !important;
          margin: 0 !important;
          padding: 0 !important;
          color: #000 !important;
        }
        
        .full-content-container h1 {
          font-size: 16px !important;
          margin: 0 0 3px 0 !important;
          padding: 0 !important;
          color: #000 !important;
          border: none !important;
        }
        
        /* Hide all unwanted elements */
        .language-selector, .language-dropdown, .lang-selector,
        #google_translate_element, .google-translate-box,
        .goog-te-combo, .goog-te-gadget, .skiptranslate,
        .buttons-container .download-buttons,
        .buttons-container .share-buttons,
        .suggested-advisors-section,
        .toggle-container, .edit-icon,
        .download-btn, .google-maps-btn, .suggested-advisors-btn,
        .tts-control-btn,
        .beta-label {
          display: none !important;
          visibility: hidden !important;
        }
        
        .disclaimer-box {
          display: block !important;
          visibility: visible !important;
          page-break-inside: avoid;
          margin-top: 10px !important;
          padding: 5px !important;
          font-size: 10px !important;
        }
      }
    `;
    document.head.appendChild(printStyles);
    
    // Force a reflow to ensure styles are applied
    document.body.offsetHeight; // eslint-disable-line no-unused-expressions
    
    // Small delay to ensure styles are applied
    setTimeout(() => {
      window.print();
      
      // Clean up after printing
      setTimeout(() => {
        document.body.classList.remove('pdf-export-mode');
        document.head.removeChild(printStyles);
        window.speechSynthesis?.cancel();
        setIsSpeaking(false);
      }, 100);
    }, 200);
  };

  const handleDeepResults = async () => {
    window.speechSynthesis?.cancel();
    setIsSpeaking(false);
    setLoadingDeepResults(true);
    try {
      const token = localStorage.getItem("token");
      const response = await axios.post(
        "/api/deepseek-search",
        {
          userInput: query,
          country: country,
          state: state,
          level: level,
        },
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );

      // Update state to show deep results in the same page
      setDeepContent(response.data.aiResponse);
      setIsDeepView(true);
      setDeepProvider("deepseek");
      
      // Scroll to top to show the new content
      window.scrollTo({ top: 0, behavior: 'smooth' });
    } catch (error) {
      console.error("Error fetching deep results:", error);
      alert("Failed to fetch deep results. Please try again.");
    } finally {
      setLoadingDeepResults(false);
    }
  };

  const handleBackToOriginal = () => {
    window.speechSynthesis?.cancel();
    setIsSpeaking(false);
    setIsDeepView(false);
    setDeepProvider(null);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const isAnyDeepLoading = loadingDeepResults;

  const pageUrl = window.location.href;

  return (
    <div className="main-wrapper">
      <div className="two-column-layout">
        <div className="content-page">
          <div className="result-content-wrapper">
            <div className="query-container">
              <h2>
                Query:
                <FontAwesomeIcon
                  icon={faPen}
                  className="edit-icon"
                  title="Edit Query"
                  onClick={() =>
                    navigate("/search", {
                      state: {
                        openDetailedSearch: true,
                        aiQuery: query,
                      },
                    })
                  }
                />
              </h2>
              <p>{query}</p>
            </div>

            {/* Toggle Button for Database/AI Answer */}
            {/* {dbResults.length > 0 && (
              <div className="toggle-container">
                <button
                  className="toggle-btn"
                  onClick={() =>
                    navigate("/other-results", {
                      state: { dbResults, district, state, country },
                    })
                  }
                >
                  Other Results
                </button>
              </div>
            )} */}

            <div className="content-sections">
              <div className="top-info-container">
                <div className="top-info-item">
                  <h3>Country:</h3>
                  <p>{country}</p>
                </div>
                {state && (
                  <div className="top-info-item">
                    <h3>State:</h3>
                    <p>{state}</p>
                  </div>
                )}
                <div className="top-info-item">
                  <h3>Search Level:</h3>
                  <p>{formatSearchLevel(level)}</p> 
                </div>
                <button
                  className="edit-search-btn"
                  onClick={() =>
                    navigate("/search", {
                      state: {
                        openDetailedSearch: true,
                        aiQuery: query,
                      },
                    })
                  }
                  title="Edit query or change search level"
                >
                  ✎ Edit Query & Levels
                </button>
              </div>

              <div className="full-content-container">
                <div className="full-content-header">
                  <h1>
                    {isDeepView
                      ? "🔍 Deep Legal Analysis"
                      : "Legal Summary"}
                  </h1>
                  <button
                    type="button"
                    className="tts-control-btn"
                    onClick={handleSpeakToggle}
                    title={isSpeaking ? "Stop reading" : "Read this content aloud"}
                    aria-label={isSpeaking ? "Stop reading content" : "Read content aloud"}
                  >
                    <FontAwesomeIcon icon={isSpeaking ? faStop : faVolumeUp} />
                  </button>
                </div>
                {mergedSummary.trim() && (
                  <div className="formatted-text" ref={ttsContainerRef}>
                    {formatText(mergedSummary)}
                  </div>
                )}
              </div>
            </div>

            {/* Mobile Action Buttons - Shown only on mobile */}
            <div className="mobile-action-buttons">
              {isDeepView ? (
                <button
                  className="suggested-advisors-btn back-to-original-btn"
                  onClick={handleBackToOriginal}
                >
                  ← Back to Original Results
                </button>
              ) : (
                <>
                  <button
                    className="suggested-advisors-btn deep-results-btn"
                    onClick={handleDeepResults}
                    disabled={isAnyDeepLoading}
                  >
                    {loadingDeepResults ? "Loading..." : "🔍 Deep Results"}
                  </button>
                </>
              )}
              {isAnyDeepLoading && (
                <div className="deep-analysis-message" style={{ marginTop: 8 }}>
                  We're performing a deeper analysis. This may take a little longer than usual.
                </div>
              )}
              
              {dbResults.length > 0 && (
                <button
                  className="suggested-advisors-btn"
                  onClick={() =>
                    navigate("/other-results", {
                      state: { dbResults, district, state, country },
                    })
                  }
                >
                  Related Results
                </button>
              )}
              <button
                className="suggested-advisors-btn"
                onClick={() => navigate("/suggested-legal-advisors", {
                  state: { district, state, country }
                })}
              >
                👥 Suggested Legal Advisors
              </button>
              
              <button
                className="suggested-advisors-btn legal-advisors-google-btn"
                onClick={() => {
                  const queryParts = [
                    "lawyer",
                    "advocate",
                    district,
                    state,
                    country
                  ].filter(Boolean);
                  const mapsQuery = encodeURIComponent(queryParts.join(" "));
                  window.open(`https://www.google.com/maps/search/${mapsQuery}`, "_blank");
                }}
              >
                🔍 Legal Advisors on Google 
              </button>
            </div>

            <div className="complaint-draft-buttons">
              <button
                className="download-btn"
                onClick={() =>
                  navigate("/complaint-drafts", {
                    state: {
                      query,
                      summary,
                      country,
                      state,
                      district,
                      lawCategory: initialLawCategory,
                      draftType: "police-only",
                    },
                  })
                }
              >
                Police Complaint Draft
              </button>

              <button
                className="download-btn"
                onClick={() =>
                  navigate("/complaint-drafts", {
                    state: {
                      query,
                      summary,
                      country,
                      state,
                      district,
                      lawCategory: initialLawCategory,
                      draftType: "department-only",
                    },
                  })
                }
              >
                Department Complaint Draft
              </button>
            </div>

            <div className="buttons-container">
              <div className="download-buttons">
                <button className="download-btn" onClick={handleDownloadPDF}>
                  <FontAwesomeIcon icon={faDownload} /> Download PDF
                </button>
                <button className="download-btn" onClick={handleDownloadText}>
                  <FontAwesomeIcon icon={faDownload} /> Download Text
                </button>
                <button className="download-btn" onClick={handlePrint}>
                  <FontAwesomeIcon icon={faPrint} /> Print Page
                </button>
              </div>

              <div className="share-buttons">
                {/* WhatsApp Share */}
                <WhatsappShareButton
                  url="https://www.uljaapp.com"
                  title={`*Legal Issue:*\n${query}\n\n*Summary:*\n${summary || "No summary available."}\n\nVisit for further queries.`}
                >
                  <FontAwesomeIcon icon={faWhatsapp} size="2x" />
                </WhatsappShareButton>

                {/* Telegram Share */}
                <TelegramShareButton
                  url=" "
                  title={`Legal Issue: ${query}\n\nSummary:\n${summary || "No summary available."}\n\nVisit for further queries: www.uljaapp.com`}
                >
                  <FontAwesomeIcon icon={faTelegram} size="2x" />
                </TelegramShareButton>

                {/* Facebook Messenger Share */}
                <FacebookShareButton
                  url=" "
                  quote={`Legal Issue: ${query}\n\nSummary:\n${summary || "No summary available."}\n\nVisit for further queries: www.uljaapp.com`}
                >
                  <FontAwesomeIcon icon={faFacebookMessenger} size="2x" />
                </FacebookShareButton>

                {/* Email Share */}
                <a
                  className="mail"
                  href={`mailto:?subject=Legal Case Summary&body=Legal Issue: ${query}%0A%0ASummary:%0A${summary || "No summary available."}%0A%0AVisit: www.uljaapp.com`}
                >
                  <FontAwesomeIcon icon={faEnvelope} size="2x" />
                </a>
              </div>

              {/* Disclaimer Section */}
              <div className="disclaimer-box">
                <p>
                  <strong>Disclaimer:</strong> The information provided here is for general guidance only.
                </p>
              </div>
            </div>
          </div>
        </div>

        <div className="suggested-advisors-section">
          {/* Deep Results / Back Button */}
          {isDeepView ? (
            <button
              className="suggested-advisors-btn back-to-original-btn"
              onClick={handleBackToOriginal}
            >
              ← Back to Original Results
            </button>
          ) : (
            <>
              <button
                className="suggested-advisors-btn deep-results-btn"
                onClick={handleDeepResults}
                disabled={isAnyDeepLoading}
              >
                {loadingDeepResults ? "Loading..." : "🔍 Deep Results"}
              </button>
            </>
          )}
          {isAnyDeepLoading && (
            <div className="deep-analysis-message" style={{ marginTop: 12 }}>
              We're performing a deeper analysis. This may take a little longer than usual.
            </div>
          )}
          
          {/* Toggle Button for Database/AI Answer */}
          {dbResults.length > 0 && (
            <button
              className="suggested-advisors-btn"
              onClick={() =>
                navigate("/other-results", {
                  state: { dbResults, district, state, country },
                })
              }
            >
              Related Results
            </button>
          )}
          <button
            className="suggested-advisors-btn"
            onClick={() => navigate("/suggested-legal-advisors", {
              state: { district, state, country }
            })}
          >
            👥 Suggested Legal Advisors
          </button>
          
          <button
            className="suggested-advisors-btn legal-advisors-google-btn"
            onClick={() => {
              const queryParts = [
                "lawyer",
                "advocate",
                district,
                state,
                country
              ].filter(Boolean);
              const mapsQuery = encodeURIComponent(queryParts.join(" "));
              window.open(`https://www.google.com/maps/search/${mapsQuery}`, "_blank");
            }}
          >
            🔍 Legal Advisors on Google 
          </button>
        </div>
      </div>
    </div>
  );
};

export default FullContent;
